import type { FunctionComponent } from 'react';

import FullscreenButton from '../FullscreenButton';

import S from './style.scss';

type PropsT = {
  fullscreen: boolean;
  onFinish: () => void;
  onToggleFullscreen: () => void;

  /** Remaining session time, pre-formatted as MM:SS. */
  sessionTime: string;

  /** Title of the currently-playing segment. */
  title: string;
};

const TopBar: FunctionComponent<PropsT> = ({
  fullscreen,
  onFinish,
  onToggleFullscreen,
  sessionTime,
  title,
}) => (
  <div className={S.container}>
    <div className={S.title}>{title}</div>
    <div className={S.meta}>
      <div className={S.sessionTime}>
        Your Session Time :
        {' '}
        <span className={S.time}>{sessionTime}</span>
      </div>
      <div className={S.controls}>
        <div className={S.fullscreenPortrait}>
          <FullscreenButton active={fullscreen} onToggle={onToggleFullscreen} />
        </div>
        <button className={S.finish} onClick={onFinish} type="button">
          Finish
        </button>
      </div>
    </div>
  </div>
);

export default TopBar;
